import { useMutation } from "@tanstack/react-query";
import { SubscriptionService } from "../../services/subscription.service";
import { ISubscription, ISubscriptionUpdateModel } from "../../models/Subscription";

export const useSubscriptionMutations = () => {
  const { mutate: createSubscription } = useMutation<any, Error, Omit<ISubscription, "id">>({
    mutationFn: async (model) => SubscriptionService.createSubscription(model),
  });

  const { mutate: updateSubscription } = useMutation<
    any,
    Error,
    { id: string; model: ISubscriptionUpdateModel }
  >({
    mutationFn: async ({ id, model }) => SubscriptionService.updateSubscription(id, model),
  });

  const { mutate: deleteSubscription } = useMutation<any, Error, string>({
    mutationFn: async (id) => SubscriptionService.deleteSubscription(id),
  });

  return {
    createSubscription,
    updateSubscription,
    deleteSubscription,
  };
};
